// IMPORT PACKAGE REFERENCES
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Autosuggest from 'react-autosuggest';
import moment from 'moment';
import Modal from 'react-responsive-modal';
import { NavLink, withRouter } from 'react-router-dom';

// IMPORT PROJECT REFERENCES

import { fetchDevice, updateDevice, fetchDevices } from '../State/Actions/DeviceActions';
import { fetchPharmacies } from '../State/Actions/PharmacyActions';

import { DeviceSections } from './DeviceSections';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';

import { DeviceRowType } from './DeviceRowType';
import { DeviceRow } from './DeviceRow';
import { DeviceSection } from './DeviceSection';
import { EventsPage } from '../Pages/EventsPage';
import { DeviceStatusInformation } from '../Pages/DeviceStatusInformation';
import { Select } from './Select';


class DeviceDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            open: false,
            attachMessage: '',
            pharmacies: [],
            selectedPharmacyId: '',
        }

        this.handleSelection = this.handleSelection.bind(this)
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };
    
    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentDidMount() {
        this.props.fetchPharmacies();
        this.props.fetchDevice(this.props.deviceId);
    }

    componentDidUpdate() {
        if (JSON.stringify(this.props.pharmacies) !== JSON.stringify(this.state.pharmacies)) {
            this.setState({ pharmacies: this.props.pharmacies });
        }
    }


    prepareToAttachPharmacy() {
        this.setState({open: true, attachMessage: 'You are about to attach this device (' + this.props.deviceId + ') to the pharmacy "' + this.state.selectedPharmacyId + '"'});
    }

    attachPharmacy() {
        // Search through the pharmacies to try and find a corresponding record that matches the entered pharmacy campaign and MDM ID name. 
        let associatedPharmacyList = this.state.pharmacies.filter(pharmacy => {
            return pharmacy.campaignName === this.state.selectedPharmacyId;
        })

        if(associatedPharmacyList.length === 0) {
            alert("No pharmacy found for that name");
        } else {
            let pharmacy = associatedPharmacyList[0];
            console.log("PHarmacy is...", pharmacy);
            let currentDeviceUUids = pharmacy.deviceUuids;

            // If the pharmacy doesn't have attached devices yet, then create a new deviceUuid subnode. 
            if (currentDeviceUUids == undefined) {
                currentDeviceUUids = {};
            }
            
            currentDeviceUUids[this.props.deviceId] = {
                uuid: this.props.deviceId,
                dateAdded: moment().format("HH:mm ddd DD-MM-YYYY").toString()
            }
            
            let newDeviceUuids = {'deviceUuids': currentDeviceUUids};
            
            // Now update the pharmacy adding the new device UUID. 
            this.props.updateDevice(newDeviceUuids, pharmacy);
            this.props.history.push('/pharmacy/' + encodeURI(pharmacy.id) + "?deviceAttached=true");
        }
    }

    handleSelection(event) {
        console.log("Handling selection...", event.target.value);
        this.setState({selectedPharmacyId: event.target.value})
    }

    deleteDevice() {
        this.props.deleteDevice(this.props.deviceId);
    }

    generateDeviceSection(device) {
        // We have to manually define how the sections are laid out.
        
        // 1. Device Info and Events.
        let rows = {};
        let sections = {};
        let row;
        let section;

        if (device !== undefined) {
            section = new DeviceSection("Device Info", rows);

            row = new DeviceRow("Device", DeviceRowType.BASIC, device.LatestSetupPharmacyId, true, <DeviceStatusInformation device={this.props.device} />);
            rows[row.uid] = row;

            if (device.eventSummary !== undefined) {
                row = new DeviceRow("Device Events", DeviceRowType.BASIC, "None", true, <EventsPage device={this.props.device} />);
                rows[row.uid] = row;
                section.rows = rows;
            }

            sections[section.uid] = section;

            rows = {};

            let historicalDevice = false
            if (device.pharmacy !== undefined) {
                if (device.pharmacy.deviceUuids.hasOwnProperty(device.LatestSetupPharmacyId)) {
                    let deviceToCheck = device.pharmacy.deviceUuids[device.LatestSetupPharmacyId] 
                    console.log("Historical", moment(deviceToCheck.dateRemoved, "HH:mm ddd DD-MM-YYYY"), moment());
                    historicalDevice = moment(deviceToCheck.dateRemoved, "HH:mm ddd DD-MM-YYYY").isBefore(moment())
                }
            }
           
            if (device.pharmacy === undefined || historicalDevice) {
                // If the pharmacy is not present then the device is considered unassigned. We should provide the user with the ability to assign the device to a pharmacy. 

                // Autosuggest will pass through all these props to the input.
                const inputProps = {
                    placeholder: 'Find a Pharmacy',
                    value: this.state.value,
                    onChange: this.onChange
                };
                
                row = new DeviceRow(<Select value={this.state.selectedPharmacyId} handleSelection={this.handleSelection} options={this.props.pharmacies.map(pharmacy => pharmacy.campaignName)} name={"pharmacies"}/>, DeviceRowType.AUTOSUGGEST, <button onClick={() => this.prepareToAttachPharmacy()} type="button" className="btn btn-primary btn-lg btn-block">Attach Pharmacy</button>, false, null, 'promotionManager', '', true);
                rows[row.uid] = row;

                section = new DeviceSection("Attach a Pharmacy", rows, null);
                section.rows = rows;
                sections[section.uid] = section;
            }

            rows = {};
            section = new DeviceSection("Delete Device", rows, null);
            row = new DeviceRow("Delete this device", DeviceRowType.NEW, <button type="button" onClick={() => this.deleteDevice()} class="btn btn-danger btn-block">Delete this Device?</button>, true, null);
            rows[row.uid] = row;

            section.rows = rows;
            sections[section.uid] = section;
        }

        return sections;
    }


    render() {
        return (
            <div className="container">
                <Modal className="centered-modal" open={this.state.open} onClose={this.onCloseModal} center>
                    <div className="centered-modal">
                        <h4 className="modal-header-title">Attaching Device</h4>
                        <div className="modal-description">{ this.state.attachMessage }</div>
                        <button onClick={() => this.attachPharmacy()} type="button" className="btn btn-primary form-right">Proceed</button>
                        <button type="button" className="cancel-button btn btn-danger form-right">Cancel</button>
                    </div>
                </Modal>
                { (this.props.fetchedDevice) && 
                    <Fragment>
                        <div className="section-header">
                            Device
                        </div>
                        <div>
                            <DeviceSections handleUpdate={this.handleUpdate} editing={this.state.editing} sections={this.generateDeviceSection(this.props.device)} />
                        </div>
                    </Fragment>
                 }
                { <LoadingIndicator busy={ this.props.fetchingDevice} /> }
                { this.props.failedDevice && <Error message="Failed to fetch list of device." /> }
            </div>
        );
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetchingDevice, fetchedDevice, failedDevice, device, devices, updating } = state.devicesReducer;
    const { pharmacies } = state.pharmaciesReducer;
    return { fetchingDevice, fetchedDevice, failedDevice, device, devices, updating, pharmacies };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ fetchDevice, updateDevice, fetchDevices, fetchPharmacies }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(DeviceDetails));


// EXPORT COMPONENT

export { hoc as DeviceDetails };